import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractFilterComponent} from '../abstract-filter.component';
import {EtlFilterDTO} from '@tj/tj-dmp-lib-api';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'dmp-list-col-etl',
    templateUrl: './list-col-etl.component.html',
    styleUrls: ['./list-col-etl.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ListColEtlComponent extends AbstractFilterComponent implements OnInit {

    @Input() etl: EtlFilterDTO;
    @Input() fields: string[] = [];
    @Input() operatorTxt: 'OR' | 'AND' = null;
    @Output() fieldsChange = new EventEmitter<string[]>();
    fieldSelected: string = null;

    constructor(protected translate: TranslateService,
                private cd: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        this.updateListCol();
    }

    updateValue() {
        if (this.fields == null) {
            this.fields = [];
        }
        this.fields.push(this.fieldSelected.slice());
        this.fieldsChange.emit(this.fields);
        this.cd.detectChanges();
        this.fieldSelected = null;
    }

    delete(fieldInput: string) {
        this.fields = this.fields.filter(f =>
            f !== fieldInput);
        this.fieldsChange.emit(this.fields);
    }

}
